import type { ColumnHelper } from '@tanstack/react-table';
import { createColumnHelper } from '@tanstack/react-table';
import type { ColumnGetters, ColumnParams, ColumnType } from './columns/index';
import columnGetters from './columns/index';

type AccessorType<TRowData> = Parameters<ColumnHelper<TRowData>['accessor']>[0];

export const createColumnGetter = <TRowData>() => {
  const columnHelper = createColumnHelper<TRowData>();

  /**
   * Utility function to generate typesafe column definitions from common column types for Datatables
   * @param columnType one of the predefined column types (e.g.: user, project, money)
   * @param accessor row property or a function to extract data for the column
   * @param columnId unique identifier for the column
   * @param params (optional) parameters to pass to the column getter
   * @returns
   */
  const getColumnDef = <T extends ColumnType>(
    columnType: T,
    accessor: AccessorType<TRowData>,
    columnId: string,
    params?: ColumnParams<T>
  ) => {
    const getter: ColumnGetters[T] = columnGetters[columnType];
    // This should probably be done with discriminated unions on the getters
    // or inferring function overloads for the getColumnDef itself
    //@ts-expect-error
    const column = getter(columnId, params);
    return columnHelper.accessor(accessor, column);
  };
  return getColumnDef;
};
